import React from 'react'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'
import Link from '../link/Link'
import VerificationDate from '../verification-date/VerificationDate'

const WebLink = ({ block, date, contributor }) => {
    return (
        <div className="web-link-block">
            {block?.content && <p>{block?.content}</p>}
            {block?.childrens && <Parser content_block={block.childrens} />}
            <div className="baseocom-flex-row-center baseocom-mb-8">
                <Link url={block.attributes?.URL} targetBlank={true} isIcon={false}>
                    {icon('teleservice')}
                    Accéder à la démarche en ligne
                </Link>
            </div>

            {date && <VerificationDate dateModified={date} contributor={contributor} />}
        </div>
    )
}

export default WebLink
